// assets/jci-warranty.js
(function () {
  if (window._jciWarrantyInit) return;
  window._jciWarrantyInit = true;

  // → "What's Covered?" popup
  document.addEventListener('click', function (e) {
    if (e.target.closest('.warranty-info-trigger')) {
      e.preventDefault();
      var overlay = document.querySelector('.warranty-popup-overlay');
      if (overlay) overlay.style.display = 'flex';
      return;
    }
    if (e.target.closest('.warranty-close')) {
      var overlay = document.querySelector('.warranty-popup-overlay');
      if (overlay) overlay.style.display = 'none';
      return;
    }
    if (e.target.classList && e.target.classList.contains('warranty-popup-overlay')) {
      e.target.style.display = 'none';
      return;
    }
  });

  // → Two-button selector
  var selectedId = null;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.warranty-plan-btn');
    if (!btn) return;

    var allBtns = document.querySelectorAll('.warranty-plan-btn');

    if (btn.classList.contains('selected')) {
      btn.classList.remove('selected');
      selectedId = null;
    } else {
      allBtns.forEach(function (b) { b.classList.remove('selected'); });
      btn.classList.add('selected');
      selectedId = btn.dataset.id;
    }
  });

  // → When the Add-to-Cart form submits, flag that we need to swap warranties
  var needSwap = false, swapCompleted = false;

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.getAttribute('action')) return;
    if (!form.getAttribute('action').startsWith('/cart/add')) return;
    if (selectedId) {
      needSwap = true;
      swapCompleted = false;
    }
  });

  // → Listen for the theme's cart:refresh on documentElement
  document.documentElement.addEventListener('cart:refresh', function () {
    if (!needSwap || swapCompleted) return;
    needSwap = false;

    var planIds = Array.from(document.querySelectorAll('.warranty-plan-btn'))
      .map(function (b) { return b.dataset.id; });
    var otherId = planIds.find(function (id) { return id !== selectedId; });

    function addWarranty() {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: selectedId, quantity: 1 })
      })
        .then(function () {
          swapCompleted = true;
          console.log('✅ Warranty swapped');
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true })
          );
        })
        .catch(function (err) {
          console.error('⚠️ Warranty swap failed:', err);
        });
    }

    if (otherId) {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: { [otherId]: 0 } })
      })
        .then(addWarranty)
        .catch(addWarranty);
    } else {
      addWarranty();
    }
  });
})();
